const ENVIRONMENT = import.meta.env.VITE_ENVIRONMENT;

export const APP_CONFIG = {
  ENVIRONMENT,
  YUBIKEY_REQUIRED: ['production'].includes(ENVIRONMENT),
  // Minutes before the end of the session when the nurse is warned
  SESSION_WARNING_MINUTES:
    Number(import.meta.env.VITE_SESSION_WARNING_MINUTES) || 15,
  SHOW_DEMO_ACCESS_PAGE: ['development', 'demo'].includes(ENVIRONMENT),
};
